module.exports = __webpack_public_path__ + "img/group.cda2e03c.png";